import { Box, Divider } from "@bcc-ui/ui-components";
import React from "react";

import style from "./navigation-sub-section.scss";

interface Props {
    children: React.ReactNode;
}

export const NavigationSubSection = (props: Props) => {
    return (
        <Box className={style.container}>
            <Box paddingLeft="Sm" paddingRight="Xxs">
                <Divider direction="Vertical" />
            </Box>
            <Box columnLayout className={style.menuItemsContainer}>
                {props.children}
            </Box>
        </Box>
    );
};
